import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs'; // Import Subject

@Injectable({
  providedIn: 'root'
})
export class TaggingService {

  // --- NEW: Add a Subject for communication ---
  private tagCreatedSource = new Subject<void>();
  public tagCreated$ = this.tagCreatedSource.asObservable();
  // -------------------------------------------

  constructor(private apiService: ApiService) {}

  // --- NEW: Method to notify listeners ---
  notifyTagCreated() {
    this.tagCreatedSource.next();
  }
  // ---------------------------------------

  // --- No changes to existing methods ---
  getTaggings(queryParams?: HttpParams): Observable<any> {
    return this.apiService.get('stock_details', queryParams);
  }

  getTagging(id: any): Observable<any> {
    return this.apiService.get(`stock_details/${id}`);
  }

  createStockDetails(data: any): Observable<any> {
    return this.apiService.post('stock_details', data);
  }

  deleteTagging(id: any): Observable<any> {
    return this.apiService.delete(`stock_details/${id}`);
  }

  getTaggingsDataOnItemCode(itemCode:any){
    return this.apiService.get(`stock_details?std_item_code=${itemCode}`);
  }

  getStockDetailsByProductType(){
    return this.apiService.get(`stock_details?std_product_type=piece-wise`);
  }

  updateStockIssue(tagId: number, payload: any) {
  return this.apiService.update(`stock_details/update-stock-issue/${tagId}`, payload);
  }

  getIssuedStock(staffId: number) {
    return this.apiService.get(`stock_details/issued/list?issued_stock_id=${staffId}`);
  }
  getIssuesStock(staffId: number) {
    return this.apiService.get(`stock_details/issued/list?issued_stock_id=${staffId}`);
  }
  getAllIssuedStock() {
    return this.apiService.get(`stock_details/issued-list`);
  }

  scanBarcode(firmId: number, barcode: string) {
    const params = new HttpParams()
      .set('std_firm_id', firmId.toString())
      .set('barcode', barcode.trim().toUpperCase());
    return this.apiService.get(`stock_details/scan-barcode`, params);
  }
}
